export default {
  mediaMix: 'Mix de Mídia',
  dataView: 'Visualização de Dados',
  close: 'Fechar',
  refresh: 'Atualizar',
  saveAsImage: 'Salvar como Imagem'
}
